module.exports = __webpack_public_path__ + "static/media/logo_az.a1cf0c4d.png";